import { ApolloProvider } from "@apollo/client"
import { BrowserRouter } from "react-router-dom"
import {
  APIErrorProvider,
  APIErrorNotification,
  apolloClient,
  config,
  initDatadog,
  initSentry,
} from "@oysterhr/core"
import { CostCalculatorPageLayout } from "@oysterhr/cost-calculator"
import "@oysterhr/quarantine/i18n"
import { ToastProvider } from "@oysterhr/ui"
import { AccountAspectContextWrapper } from "@oysterhr/identity/AccountAspectContext"

if (config.environmentIsProductionLike) {
  initSentry({
    dsn: window.SENTRY_DSN,
    environment: config.environment,
    release: window.SENTRY_RELEASE,
  })
  initDatadog({
    env: config.environment,
    version: window.SENTRY_RELEASE,
  })
}

const csrfToken =
  document.querySelector("meta[name='csrf-token']")?.attributes.getNamedItem("content")?.value ||
  null
const client = apolloClient({
  connectToDevTools: !config.isProductionEnvironment,
  csrfToken,
  uri: `${config.endpoints.app}/api/graphql/cost-calculator`,
})

export const AppTaxCalculator = () => {
  return (
    <BrowserRouter>
      <ToastProvider>
        <ApolloProvider client={client}>
          <APIErrorProvider>
            <APIErrorNotification />
            <AccountAspectContextWrapper skipFetchAspects>
              <CostCalculatorPageLayout />
            </AccountAspectContextWrapper>
          </APIErrorProvider>
        </ApolloProvider>
      </ToastProvider>
    </BrowserRouter>
  )
}
